import React, { useState } from "react";
import ButtonFill from "../../components/button/ButtonFill";
import ButtonOutline from "../../components/button/ButtonOutline";
import dojaCatBanner from "../../media/images/doja-cat-banner.jpg";
import ArtistTabs from "./ArtistTabs";
import Popular from "./ArtistTabs/Popular";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";

const ArtistPage = () => {
  const data = [
    {
      name: "Popular",
      children: <Popular />,
    },
    {
      name: "All Songs",
      children: <h1>All Songs coming soon</h1>,
    },
    {
      name: "Albums",
      children: <h1>Albums coming soon</h1>,
    },
    {
      name: "About",
      children: <h1>About coming soon</h1>,
    },
  ];

  const [activeTab, setactiveTab] = useState(data[0].name);

  return (
    <div className="artist-page">
      <div className="artist-details">
        <img src={dojaCatBanner} alt="doja cat banner" />
        <div className="bg-dark" />
        <div className="content">
          <div className="left">
            <div className="name">
              <h1>Doja Cat</h1>
              <div className="badge">
                <VerifiedRoundedIcon />
              </div>
              <p>Verified Artist</p>
            </div>
            <p className="followers">50 + Million Followers</p>
          </div>

          <div className="right">
            <ButtonFill iconLeft={<PlayArrowRoundedIcon />} text="Play All" />
            <ButtonOutline iconLeft={<AddRoundedIcon />} text="Follow" />
          </div>
        </div>
      </div>

      <ArtistTabs data={data} activeTab={activeTab} setactiveTab={setactiveTab} />
    </div>
  );
};

export default ArtistPage;
